import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import CivilStatusForm from './form';
import {
  NewPersonVM,
  AccordionCivilStatus,
} from 'shell/components/shared/sipo-person-form/new-person';

const CivilStatusComponent = ({
  setHasChangedCivilStatus,
}: {
  setHasChangedCivilStatus: (hasChanged: boolean) => void;
}): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldCivilStatusChange = useEventCallback(
    (key: keyof AccordionCivilStatus, value: AccordionCivilStatus[keyof AccordionCivilStatus]) => {
      formContext.setFieldValue('civilStatus', {
        ...(formContext.values.civilStatus || {}),
        [key]: value,
      });
    }
  );

  const onFieldsCivilStatusChange = useEventCallback((value: AccordionCivilStatus) => {
    formContext.setFieldValue('civilStatus', {
      ...(formContext.values.civilStatus || {}),
      ...value,
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-civil-status-content"
        id="panel-person-civil-status-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Stato Civile</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CivilStatusForm
          values={formContext.values.civilStatus}
          onChange={onFieldCivilStatusChange}
          onChanges={onFieldsCivilStatusChange}
          setHasChangedCivilStatus={setHasChangedCivilStatus}
          errors={formContext.errors.civilStatus as FormikErrors<AccordionCivilStatus>}
          touched={
            formContext.touched.civilStatus as unknown as FormikTouched<AccordionCivilStatus>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

CivilStatusComponent.displayName = 'Accordion civil status component';

const CivilStatus = memo(CivilStatusComponent);

export default CivilStatus;
